import React from "react";
import { FaSms, FaPhoneAlt, FaEnvelope, FaFacebookF, FaLinkedinIn, FaTelegramPlane, FaInstagram, FaTwitter } from "react-icons/fa"; // Importing icons
import "./ContactButtons.css";

function ContactButtons() {
  return (
    <>
 
    <div className="contact-buttons">
      <div>
        <button>
          <FaSms className="icons" />
        </button>
        <span>Text</span>
      </div>
      <div>
        <button>
          <FaPhoneAlt className="icons" />
        </button>
        <span>Call</span>
      </div>
      <div>
        <button>
          <FaEnvelope className="icons" />
        </button>
        <span>Email</span>
      </div>
    </div>
    <div className="contact-buttons2">
            <button>
                <FaFacebookF className="icons"/>  
            </button>
            <button>
                <FaLinkedinIn className="icons" />  
            </button>
            <button>
                <FaTelegramPlane className="icons" />  
            </button>
            <button>
                <FaInstagram className="icons" />  
            </button>
            <button>
                <FaTwitter className="icons" />  
            </button>
        </div>
    </>
  );
}

export default ContactButtons;
